import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button, Title } from 'components/misc'
import { Modal } from 'components/layout'
import { modal } from 'redux/modules/app'
import config from 'config'
import { logout } from 'redux/modules/auth'
import { ROLES } from 'constants/enums'

@connect(
  ({ auth }) => ({
    user: auth.user
  }),
  { logout, modal }
)
class AlreadyLoggedInModal extends Component {
  static propTypes = {
    user: PropTypes.object,
    logout: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  state = {
    visible: false,
    targetUrl: null
  }

  componentDidMount() {
    this.checkAlreadyLoggedIn()
  }

  componentDidUpdate(prevProps) {
    const prevToken = get(prevProps.user, 'access_token')
    const newToken = get(this.props.user, 'access_token')

    if (!prevToken && newToken) {
      this.checkAlreadyLoggedIn()
    }
  }

  checkAlreadyLoggedIn = () => {
    const { user, modal } = this.props

    if (typeof window === 'undefined' || !user) {
      return
    }

    const grants = get(user, 'grant', [])
    const preferred = user.prefferedOrganisation
    const grantCount = grants.length

    let targetUrl = null

    if (grantCount === 1) {
      if (grants[0].u === ROLES.PARTICIPANT.u) {
        targetUrl = config.baseUrl
      } else {
        targetUrl = config.boUrl
      }
    } else if (grantCount > 1) {
      const hasParticipant = grants.some(g => {
        return g.u === ROLES.PARTICIPANT.u
      })

      if (hasParticipant) {
        if (preferred && preferred.userType === ROLES.PARTICIPANT.u) {
          targetUrl = config.baseUrl
        } else {
          targetUrl = config.boUrl
        }
      } else {
        targetUrl = config.boUrl
      }
    }

    const normalizeBasePath = url => {
      return new URL(url).pathname.replace(/\/$/, '')
    }

    const isBaseFoUrl = (currentUrl, baseUrl) => {
      return normalizeBasePath(currentUrl) === normalizeBasePath(baseUrl)
    }

    if (targetUrl !== null && isBaseFoUrl(window.location.href, config.baseUrl)) {
      this.setState({ visible: true, targetUrl })
      modal('modal-already-logged-in')
    }
  }

  handleGoToApp = () => {
    const { targetUrl } = this.state

    if (targetUrl) {
      window.location.replace(targetUrl)
    }
  }

  handleLogout = () => {
    const { logout, modal } = this.props

    logout().finally(() => {
      modal(null)
    })
    this.setState({ visible: false })
  }

  render() {
    const { visible } = this.state

    if (!visible) {
      return null
    }

    return (
      <Modal id="modal-already-logged-in" customActions>
        <div className="base-margin text--center">
          <Title h2>
            <FormattedMessage
              id="label.already_logged_in"
              defaultMessage="You are already logged in another tab."
            />
          </Title>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              justifyContent: 'center',
              marginTop: '20px'
            }}
          >
            <Button secondary onClick={this.handleGoToApp}>
              <FormattedMessage id="button.go_back_to_app" defaultMessage="Go back to the app" />
            </Button>
            <Button onClick={this.handleLogout}>
              <FormattedMessage id="button.logout" defaultMessage="Logout" />
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default AlreadyLoggedInModal
